export default "__VITE_ASSET__B_En1xAW__"